import { useFlags } from 'launchdarkly-react-client-sdk';

// Pooled stops: a location without a routing cohort can be opted into automated routing, and the
// truck count card sizes the warehouse pool. A global boolean, off by default, so every screen
// behaves as before until it is turned on.
export const usePooledStopsEnabled = (): boolean => {
  const { automatedRoutingPooledStops = false } = useFlags();

  return automatedRoutingPooledStops === true;
};
